import { render } from "./RetirementPgCalculator.vue?vue&type=template&id=1e5d1196"
import script from "./RetirementPgCalculator.vue?vue&type=script&lang=js"
export * from "./RetirementPgCalculator.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__